/**
 * Generated from PostcardBeijing2Layout.fla
 */
export function PostcardBeijing2Layout(this: IPostcardBeijing2Layout) {
	const main = this.main;
	PostcardBeijing2Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardBeijing2Layout_main(this: IPostcardBeijing2Layout_main) {
	const postcard = this.postcard;
	PostcardBeijing2Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardBeijing2Layout_postcard(this: IPostcardBeijing2Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardBeijing2Layout_cardTransform1.call(cardTransform[0] as IPostcardBeijing2Layout_cardTransform1);
		cardTransform[0].x = 532.6;
		cardTransform[0].y = -351.25;
		cardTransform[0].width = 520.08;
		cardTransform[0].height = 651.91;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardBeijing2Layout_cardTransform2.call(cardTransform[1] as IPostcardBeijing2Layout_cardTransform2);
		cardTransform[1].x = 394.05;
		cardTransform[1].y = 347.9;
		cardTransform[1].width = 237.04;
		cardTransform[1].height = 297.12;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardBeijing2Layout_cardTransform3.call(cardTransform[2] as IPostcardBeijing2Layout_cardTransform3);
		cardTransform[2].x = -210.45;
		cardTransform[2].y = 355.6;
		cardTransform[2].width = 106.45;
		cardTransform[2].height = 133.44;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardBeijing2Layout_cardTransform4.call(cardTransform[3] as IPostcardBeijing2Layout_cardTransform4);
		cardTransform[3].x = -132.45;
		cardTransform[3].y = 414.9;
		cardTransform[3].width = 262.49;
		cardTransform[3].height = 329.03;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardBeijing2Layout_cardTransform5.call(cardTransform[4] as IPostcardBeijing2Layout_cardTransform5);
		cardTransform[4].x = 655.95;
		cardTransform[4].y = 376.1;
		cardTransform[4].width = 322.35;
		cardTransform[4].height = 404.06;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardBeijing2Layout_cardTransform6.call(cardTransform[5] as IPostcardBeijing2Layout_cardTransform6);
		cardTransform[5].x = -642.35;
		cardTransform[5].y = 181;
		cardTransform[5].width = 422.46;
		cardTransform[5].height = 529.54;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardBeijing2Layout_cardTransform7.call(cardTransform[6] as IPostcardBeijing2Layout_cardTransform7);
		cardTransform[6].x = -459.65;
		cardTransform[6].y = -287.7;
		cardTransform[6].width = 685.53;
		cardTransform[6].height = 859.29;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardBeijing2Layout_cardTransform8.call(cardTransform[7] as IPostcardBeijing2Layout_cardTransform8);
		cardTransform[7].x = 7.85;
		cardTransform[7].y = -396.7;
		cardTransform[7].width = 574.75;
		cardTransform[7].height = 720.43;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[0]) {
		PostcardBeijing2Layout_pieces8.call(items[0] as IPostcardBeijing2Layout_pieces8);
		(items[0] as IPostcardBeijing2Layout_pieces8).dependsOn = 0;
		(items[0] as IPostcardBeijing2Layout_pieces8).outlineGlow = true;
		items[0].x = 13.15;
		items[0].y = -389.6;
		items[0].width = 499.00;
		items[0].height = 495.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardBeijing2Layout_outlines8.call(items[1] as IPostcardBeijing2Layout_outlines8);
		items[1].x = 10.7;
		items[1].y = -390.4;
		items[1].width = 369.00;
		items[1].height = 361.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"dependsOn":7});
	}
	if (items[2]) {
		PostcardBeijing2Layout_decorationBeijing21.call(items[2] as IPostcardBeijing2Layout_decorationBeijing21);
		(items[2] as IPostcardBeijing2Layout_decorationBeijing21).dependsOn = 7;
		items[2].x = 698.4;
		items[2].y = 32.55;
		items[2].width = 396.00;
		items[2].height = 502.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardBeijing2Layout_pieces7.call(items[3] as IPostcardBeijing2Layout_pieces7);
		items[3].x = -454.2;
		items[3].y = -326.45;
		items[3].width = 638.00;
		items[3].height = 580.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"dependsOn":7});
	}
	if (items[4]) {
		PostcardBeijing2Layout_decorationBeijing23.call(items[4] as IPostcardBeijing2Layout_decorationBeijing23);
		(items[4] as IPostcardBeijing2Layout_decorationBeijing23).dependsOn = 7;
		items[4].x = 256.55;
		items[4].y = -196.95;
		items[4].width = 553.00;
		items[4].height = 586.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"dependsOn":7});
	}
	if (items[5]) {
		PostcardBeijing2Layout_decorationBeijing22.call(items[5] as IPostcardBeijing2Layout_decorationBeijing22);
		(items[5] as IPostcardBeijing2Layout_decorationBeijing22).dependsOn = 7;
		items[5].x = -652.6;
		items[5].y = 72.3;
		items[5].width = 381.00;
		items[5].height = 448.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[6]) {
		PostcardBeijing2Layout_pieces1.call(items[6] as IPostcardBeijing2Layout_pieces1);
		(items[6] as IPostcardBeijing2Layout_pieces1).dependsOn = 0;
		(items[6] as IPostcardBeijing2Layout_pieces1).outlineGlow = true;
		items[6].x = 531.7;
		items[6].y = -354.7;
		items[6].width = 522.00;
		items[6].height = 516.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardBeijing2Layout_outlines1.call(items[7] as IPostcardBeijing2Layout_outlines1);
		items[7].x = 532.1;
		items[7].y = -354.55;
		items[7].width = 415.00;
		items[7].height = 407.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardBeijing2Layout_outlines7.call(items[8] as IPostcardBeijing2Layout_outlines7);
		items[8].x = -453.3;
		items[8].y = -322.65;
		items[8].width = 590.00;
		items[8].height = 533.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[9]) {
		PostcardBeijing2Layout_pieces6.call(items[9] as IPostcardBeijing2Layout_pieces6);
		(items[9] as IPostcardBeijing2Layout_pieces6).dependsOn = 0;
		(items[9] as IPostcardBeijing2Layout_pieces6).outlineGlow = true;
		items[9].x = -638.55;
		items[9].y = 190.2;
		items[9].width = 297.00;
		items[9].height = 404.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardBeijing2Layout_outlines6.call(items[10] as IPostcardBeijing2Layout_outlines6);
		items[10].x = -638.35;
		items[10].y = 186.65;
		items[10].width = 297.00;
		items[10].height = 395.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"dependsOn":5});
	}
	if (items[11]) {
		PostcardBeijing2Layout_decorationBeijing24.call(items[11] as IPostcardBeijing2Layout_decorationBeijing24);
		(items[11] as IPostcardBeijing2Layout_decorationBeijing24).dependsOn = 5;
		items[11].x = -130.3;
		items[11].y = 206.4;
		items[11].width = 241.00;
		items[11].height = 382.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"dependsOn":5});
	}
	if (items[12]) {
		PostcardBeijing2Layout_decorationBeijing25.call(items[12] as IPostcardBeijing2Layout_decorationBeijing25);
		(items[12] as IPostcardBeijing2Layout_decorationBeijing25).dependsOn = 5;
		items[12].x = 179.3;
		items[12].y = 169.05;
		items[12].width = 383.00;
		items[12].height = 490.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"dependsOn":2});
	}
	if (items[13]) {
		PostcardBeijing2Layout_decorationBeijing26.call(items[13] as IPostcardBeijing2Layout_decorationBeijing26);
		(items[13] as IPostcardBeijing2Layout_decorationBeijing26).dependsOn = 2;
		items[13].x = 312.65;
		items[13].y = 257.55;
		items[13].width = 241.00;
		items[13].height = 307.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"dependsOn":5});
	}
	if (items[14]) {
		PostcardBeijing2Layout_decorationBeijing28.call(items[14] as IPostcardBeijing2Layout_decorationBeijing28);
		(items[14] as IPostcardBeijing2Layout_decorationBeijing28).dependsOn = 5;
		items[14].x = 356;
		items[14].y = 277.1;
		items[14].width = 31.00;
		items[14].height = 48.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"dependsOn":4,"outlineGlow":false});
	}
	if (items[15]) {
		PostcardBeijing2Layout_pieces3.call(items[15] as IPostcardBeijing2Layout_pieces3);
		(items[15] as IPostcardBeijing2Layout_pieces3).dependsOn = 4;
		(items[15] as IPostcardBeijing2Layout_pieces3).outlineGlow = false;
		items[15].x = -209.35;
		items[15].y = 349.05;
		items[15].width = 252.00;
		items[15].height = 528.00;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"dependsOn":4});
	}
	if (items[16]) {
		PostcardBeijing2Layout_decorationBeijing29.call(items[16] as IPostcardBeijing2Layout_decorationBeijing29);
		(items[16] as IPostcardBeijing2Layout_decorationBeijing29).dependsOn = 4;
		items[16].x = -417.25;
		items[16].y = 434.2;
		items[16].width = 160.00;
		items[16].height = 112.00;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,undefined);
	}
	if (items[17]) {
		PostcardBeijing2Layout_pieces4.call(items[17] as IPostcardBeijing2Layout_pieces4);
		items[17].x = -130.05;
		items[17].y = 420.55;
		items[17].width = 204.00;
		items[17].height = 117.00;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,undefined);
	}
	if (items[18]) {
		PostcardBeijing2Layout_outlines4.call(items[18] as IPostcardBeijing2Layout_outlines4);
		items[18].x = -130.3;
		items[18].y = 417.3;
		items[18].width = 199.00;
		items[18].height = 111.00;
		if (items[18].onLayout) items[18].onLayout();
	}
	if (!items[19] && items.elementFactory) {
		items[19] = items.elementFactory(19,{"dependsOn":2});
	}
	if (items[19]) {
		PostcardBeijing2Layout_decorationBeijing27.call(items[19] as IPostcardBeijing2Layout_decorationBeijing27);
		(items[19] as IPostcardBeijing2Layout_decorationBeijing27).dependsOn = 2;
		items[19].x = 528.05;
		items[19].y = 300.55;
		items[19].width = 73.00;
		items[19].height = 143.00;
		if (items[19].onLayout) items[19].onLayout();
	}
	if (!items[20] && items.elementFactory) {
		items[20] = items.elementFactory(20,undefined);
	}
	if (items[20]) {
		PostcardBeijing2Layout_pieces2.call(items[20] as IPostcardBeijing2Layout_pieces2);
		items[20].x = 397.2;
		items[20].y = 360.25;
		items[20].width = 162.00;
		items[20].height = 168.99;
		if (items[20].onLayout) items[20].onLayout();
	}
	if (!items[21] && items.elementFactory) {
		items[21] = items.elementFactory(21,undefined);
	}
	if (items[21]) {
		PostcardBeijing2Layout_outlines2.call(items[21] as IPostcardBeijing2Layout_outlines2);
		items[21].x = 397.65;
		items[21].y = 357.9;
		items[21].width = 163.00;
		items[21].height = 165.00;
		if (items[21].onLayout) items[21].onLayout();
	}
	if (!items[22] && items.elementFactory) {
		items[22] = items.elementFactory(22,undefined);
	}
	if (items[22]) {
		PostcardBeijing2Layout_pieces5.call(items[22] as IPostcardBeijing2Layout_pieces5);
		items[22].x = 650.2;
		items[22].y = 382.3;
		items[22].width = 254.00;
		items[22].height = 305.00;
		if (items[22].onLayout) items[22].onLayout();
	}
	if (!items[23] && items.elementFactory) {
		items[23] = items.elementFactory(23,undefined);
	}
	if (items[23]) {
		PostcardBeijing2Layout_outlines5.call(items[23] as IPostcardBeijing2Layout_outlines5);
		items[23].x = 655.75;
		items[23].y = 382.8;
		items[23].width = 247.00;
		items[23].height = 294.00;
		if (items[23].onLayout) items[23].onLayout();
	}
	const background = this.background;
	PostcardBeijing2Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardBeijing2Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardBeijing2Layout_background(this: IPostcardBeijing2Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-beijing-2.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_cardTransform6(this: IPostcardBeijing2Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-6.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_cardTransform8(this: IPostcardBeijing2Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-8.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_cardTransform7(this: IPostcardBeijing2Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_cardTransform5(this: IPostcardBeijing2Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-5.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_cardTransform4(this: IPostcardBeijing2Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-4.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_cardTransform3(this: IPostcardBeijing2Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-3.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_cardTransform1(this: IPostcardBeijing2Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-1.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_cardTransform2(this: IPostcardBeijing2Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-2-2.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_pieces8(this: IPostcardBeijing2Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-8.png", 0.527, 0.491);
	return this;
}
function PostcardBeijing2Layout_outlines8(this: IPostcardBeijing2Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-2-8.png", 0.501, 0.501);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing21(this: IPostcardBeijing2Layout_decorationBeijing21) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-1.png", 0.591, 0.500);
	return this;
}
function PostcardBeijing2Layout_pieces7(this: IPostcardBeijing2Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-7.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing23(this: IPostcardBeijing2Layout_decorationBeijing23) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-3.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing22(this: IPostcardBeijing2Layout_decorationBeijing22) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-2.png", 0.570, 0.500);
	return this;
}
function PostcardBeijing2Layout_pieces1(this: IPostcardBeijing2Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-1.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_outlines1(this: IPostcardBeijing2Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-2-1.png", 0.501, 0.501);
	return this;
}
function PostcardBeijing2Layout_outlines7(this: IPostcardBeijing2Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-2-7.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing2Layout_pieces6(this: IPostcardBeijing2Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-6.png", 0.502, 0.500);
	return this;
}
function PostcardBeijing2Layout_outlines6(this: IPostcardBeijing2Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-2-6.png", 0.502, 0.501);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing24(this: IPostcardBeijing2Layout_decorationBeijing24) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-4.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing25(this: IPostcardBeijing2Layout_decorationBeijing25) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-5.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing26(this: IPostcardBeijing2Layout_decorationBeijing26) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-6.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing28(this: IPostcardBeijing2Layout_decorationBeijing28) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-8.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_pieces3(this: IPostcardBeijing2Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-3.png", 0.913, 0.835);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing29(this: IPostcardBeijing2Layout_decorationBeijing29) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-9.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_pieces4(this: IPostcardBeijing2Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-4.png", 0.500, 0.504);
	return this;
}
function PostcardBeijing2Layout_outlines4(this: IPostcardBeijing2Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-2-4.png", 0.503, 0.505);
	return this;
}
function PostcardBeijing2Layout_decorationBeijing27(this: IPostcardBeijing2Layout_decorationBeijing27) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-2-7.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_pieces2(this: IPostcardBeijing2Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-2.png", 0.500, 0.503);
	return this;
}
function PostcardBeijing2Layout_outlines2(this: IPostcardBeijing2Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-2-2.png", 0.503, 0.503);
	return this;
}
function PostcardBeijing2Layout_pieces5(this: IPostcardBeijing2Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-2-5.png", 0.488, 0.485);
	return this;
}
function PostcardBeijing2Layout_outlines5(this: IPostcardBeijing2Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-2-5.png", 0.502, 0.500);
	return this;
}
function PostcardBeijing2Layout_postcardOverlay(this: IPostcardBeijing2Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing2Layout_postcardMask(this: IPostcardBeijing2Layout_postcardMask) {
	return this;
}
interface IPostcardBeijing2LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardBeijing2LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardBeijing2LayoutSprite extends IPostcardBeijing2LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardBeijing2LayoutText extends IPostcardBeijing2LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardBeijing2LayoutPolygon extends Array<number> {
}
interface IPostcardBeijing2Layout {
	readonly main: IPostcardBeijing2Layout_main;
}
interface IPostcardBeijing2Layout_main extends IPostcardBeijing2LayoutContainer {
	readonly postcard: IPostcardBeijing2Layout_postcard;
}
interface IPostcardBeijing2Layout_postcard extends IPostcardBeijing2LayoutContainer {
	readonly cardTransform: IPostcardBeijing2LayoutArray<IPostcardBeijing2Layout_cardTransform1|IPostcardBeijing2Layout_cardTransform2|IPostcardBeijing2Layout_cardTransform3|IPostcardBeijing2Layout_cardTransform4|IPostcardBeijing2Layout_cardTransform5|IPostcardBeijing2Layout_cardTransform6|IPostcardBeijing2Layout_cardTransform7|IPostcardBeijing2Layout_cardTransform8>;
	readonly items: IPostcardBeijing2LayoutArray<IPostcardBeijing2Layout_pieces8|IPostcardBeijing2Layout_outlines8|IPostcardBeijing2Layout_decorationBeijing21|IPostcardBeijing2Layout_pieces7|IPostcardBeijing2Layout_decorationBeijing23|IPostcardBeijing2Layout_decorationBeijing22|IPostcardBeijing2Layout_pieces1|IPostcardBeijing2Layout_outlines1|IPostcardBeijing2Layout_outlines7|IPostcardBeijing2Layout_pieces6|IPostcardBeijing2Layout_outlines6|IPostcardBeijing2Layout_decorationBeijing24|IPostcardBeijing2Layout_decorationBeijing25|IPostcardBeijing2Layout_decorationBeijing26|IPostcardBeijing2Layout_decorationBeijing28|IPostcardBeijing2Layout_pieces3|IPostcardBeijing2Layout_decorationBeijing29|IPostcardBeijing2Layout_pieces4|IPostcardBeijing2Layout_outlines4|IPostcardBeijing2Layout_decorationBeijing27|IPostcardBeijing2Layout_pieces2|IPostcardBeijing2Layout_outlines2|IPostcardBeijing2Layout_pieces5|IPostcardBeijing2Layout_outlines5>;
	readonly background: IPostcardBeijing2Layout_background;
	readonly postcardOverlay: IPostcardBeijing2Layout_postcardOverlay;
	readonly postcardMask: IPostcardBeijing2Layout_postcardMask;
}
interface IPostcardBeijing2Layout_background extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform6 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform8 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform7 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform5 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform4 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform3 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform1 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_cardTransform2 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_pieces8 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardBeijing2Layout_outlines8 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_decorationBeijing21 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_pieces7 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_decorationBeijing23 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_decorationBeijing22 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_pieces1 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardBeijing2Layout_outlines1 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_outlines7 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_pieces6 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardBeijing2Layout_outlines6 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_decorationBeijing24 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_decorationBeijing25 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_decorationBeijing26 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_decorationBeijing28 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_pieces3 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardBeijing2Layout_decorationBeijing29 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_pieces4 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_outlines4 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_decorationBeijing27 extends IPostcardBeijing2LayoutSprite {
	dependsOn: number;
}
interface IPostcardBeijing2Layout_pieces2 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_outlines2 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_pieces5 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_outlines5 extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_postcardOverlay extends IPostcardBeijing2LayoutSprite {
}
interface IPostcardBeijing2Layout_postcardMask extends IPostcardBeijing2LayoutPolygon {
}
